import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useLazyDownloadLogZipQuery,} from '~/api/logs/LoggingService.api';
import download from 'downloadjs';
import OverlayTrigger from "@rio-cloud/rio-uikit/lib/es/OverlayTrigger";
import Tooltip from "@rio-cloud/rio-uikit/lib/es/Tooltip";
import Notification from '@rio-cloud/rio-uikit/lib/es/Notification';

interface LogFilesDownloadZipButtonProps {
    id: string;
    showWarning: boolean;
}

const LogFilesDownloadZipButton: React.FC<LogFilesDownloadZipButtonProps> = ({id, showWarning}) => {
    const [downloadLogZip] = useLazyDownloadLogZipQuery<any>();

    const handleOnClick = async () => {
        try {
            const result = await downloadLogZip(id).unwrap();
            try {
                const response = await fetch(result, {
                    method: 'GET',
                    headers: {
                        Accept: 'application/octet-stream',
                        'Content-Type': 'application/octet-stream',
                    },
                });
                const data = await response.blob();
                download(data, `outputZip_${id}.zip`, 'application/octet-stream');
                Notification.success(
                    <FormattedMessage id="intl-msg:logs.downloadZip.success" defaultMessage="Log files downloaded successfully" />
                );
            } catch (error) {
                console.error('Error downloading file:', error);
                Notification.error(
                    <FormattedMessage
                        id="intl-msg:logs.downloadZip.error"
                        defaultMessage="Error downloading log files: {errorMessage}"
                        values={{ errorMessage: JSON.stringify(error?.data || '') }}
                    />
                );
            }
        } catch (error) {
            console.error('Error fetching download URL:', error);
            Notification.error(
                <FormattedMessage
                    id="intl-msg:logs.downloadZip.error"
                    defaultMessage="Error downloading log files: {errorMessage}"
                    values={{ errorMessage: JSON.stringify(error?.data || '')}}
                />
            );
        }
    };

    return (
        <div className='btn-toolbar pull-right'>
            <div className='btn-group display-flex'>
                <div className='d-flex align-items-center'>
                    <FormattedMessage id='intl-msg:download'>
                        {title =>
                            <OverlayTrigger placement='top' overlay={
                                <Tooltip id='tooltip' className='top-right'>
                                    <FormattedMessage id={'intl-msg:logs.downloadZip.tooltip'}/>
                                </Tooltip>}>
                                <span
                                    className='rioglyph rioglyph-download'
                                    title={title}
                                    data-key={id}
                                    onClick={handleOnClick}
                                    style={{ cursor: 'pointer', fontSize: '16px' }}
                                    aria-hidden='true'>
                                </span>
                            </OverlayTrigger>
                        }
                    </FormattedMessage>
                    {showWarning &&
                        <OverlayTrigger placement='top' overlay={
                            <Tooltip id='tooltip' className='top-right'>
                                <FormattedMessage id='intl-msg:downloadLogs.warning'/>
                            </Tooltip>}>
                            <span className={'rioglyph rioglyph-exclamation-sign text-color-warning ml-1'} style={{ fontSize: '16px' }}/>
                        </OverlayTrigger>
                    }
                </div>
            </div>
        </div>
        );

};

export default LogFilesDownloadZipButton;
